var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import { ChartSeriesVisibility } from '@web/components/layout/RechartsItems/ChartSeriesVisibility';
import CustomTooltip from '@web/components/layout/RechartsItems/CustomTooltip';
import { createEdgePositionedBarTooltipContent } from '@web/components/layout/RechartsItems/EdgePositionedBarTooltip';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { rechartsDiagonalStripeFillUrl, rechartsDiagonalStripePatternDefs } from '@web/components/layout/RechartsItems/rechartsDiagonalStripes';
import { renderStackedBarCells } from '@web/components/layout/RechartsItems/StackedBarCells';
import { Widget } from '@web/components/layout/Widget';
import { WidgetChartPlotArea } from '@web/components/layout/WidgetChartPlotArea/WidgetChartPlotArea';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { COMMUNICATION_BY_WEEKDAYS_CONFIG, TablesDiffColorsConfig } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { isAiButtonDisabled } from '@web/utility';
import { createPeriodComparisonSeriesLabelFormatter, formatTooltipFilterDateRange, getTooltipPeriodReferenceYear } from '@web/utility/ tooltip/periodComparisonTooltip';
import { ComparisonPeriod, getCommunicationWeekdayChannelFromBarDataKey, navigateCommunicationWeekdayBarClick } from '@web/utility/chartNavigation';
import { getPeriodBarChartLayoutProps, isBarChartRowsEmpty } from '@web/utility/charts';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { diffComparisonType, diffComparisonValueFormat } from '@workalizer/shared/types';
import { formatDuration, getPercentageDiff, getPreviousPeriod } from '@workalizer/shared/utils';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
var PERIODS = {
    CURRENT: 'currentPeriod',
    PREVIOUS: 'previousPeriod'
};
var COMMUNICATION_BY_WEEKDAYS_BAR_DATA_KEYS = [
    'previousPeriodEmails',
    'previousPeriodChat',
    'previousPeriodMeetings',
    'previousPeriodDocs',
    'currentPeriodEmails',
    'currentPeriodChat',
    'currentPeriodMeetings',
    'currentPeriodDocs',
    'teamAverageEmails',
    'teamAverageChat',
    'teamAverageMeetings',
    'teamAverageDocs'
];
var COMMUNICATION_BY_WEEKDAYS_TEAM_BAR_DATA_KEYS = [
    'teamAverageEmails',
    'teamAverageChat',
    'teamAverageMeetings',
    'teamAverageDocs'
];
var COMMUNICATION_BY_WEEKDAYS_TEAM_BAR_KEY_TO_CHANNEL = {
    teamAverageChat: 'chat',
    teamAverageDocs: 'docs',
    teamAverageMeetings: 'meetings',
    teamAverageEmails: 'emails'
};
var communicationByWeekdaysTeamStripePatternId = function (dataKey) {
    return "".concat(InsightTypeEnum.communicationDistributionByWeekdays, "_").concat(dataKey);
};
var COMMUNICATION_BY_WEEKDAYS_TEAM_STRIPE_ENTRIES = COMMUNICATION_BY_WEEKDAYS_TEAM_BAR_DATA_KEYS.map(function (dataKey) {
    var channel = COMMUNICATION_BY_WEEKDAYS_TEAM_BAR_KEY_TO_CHANNEL[dataKey];
    return {
        patternId: communicationByWeekdaysTeamStripePatternId(dataKey),
        chartColor: COMMUNICATION_BY_WEEKDAYS_CONFIG[channel].teamChartColor
    };
});
function isCommunicationByWeekdaysBarDataKey(value) {
    return (value !== undefined &&
        COMMUNICATION_BY_WEEKDAYS_BAR_DATA_KEYS.includes(value));
}
var SECONDS_PER_HOUR = 3600;
var SECONDS_PER_MINUTE = 60;
function formatWeekdayChartAxisSeconds(seconds) {
    var s = Math.max(0, Number(seconds));
    if (s === 0)
        return '0';
    if (s < SECONDS_PER_HOUR)
        return "".concat(Math.round(s / SECONDS_PER_MINUTE), "m");
    return "".concat(Math.round(s / SECONDS_PER_HOUR), "h");
}
function eventCountForDataKey(dataKey, row) {
    if (!row || !isCommunicationByWeekdaysBarDataKey(dataKey))
        return undefined;
    var countKey = "".concat(dataKey, "EventCount");
    return row[countKey];
}
function calculateTotals(data, period) {
    if (!data) {
        return {
            meetingsDuration: 0,
            docsDuration: 0,
            chatDuration: 0,
            emailsDuration: 0,
            meetingsEventCount: 0,
            docsEventCount: 0,
            chatEventCount: 0,
            emailsEventCount: 0
        };
    }
    return {
        meetingsDuration: data.reduce(function (sum, day) { return sum + day[period].meetingsDuration; }, 0),
        docsDuration: data.reduce(function (sum, day) { return sum + day[period].docsDuration; }, 0),
        chatDuration: data.reduce(function (sum, day) { return sum + day[period].chatDuration; }, 0),
        emailsDuration: data.reduce(function (sum, day) { return sum + day[period].gmailDuration; }, 0),
        meetingsEventCount: data.reduce(function (sum, day) { return sum + day[period].meetingsEventCount; }, 0),
        docsEventCount: data.reduce(function (sum, day) { return sum + day[period].docsEventCount; }, 0),
        chatEventCount: data.reduce(function (sum, day) { return sum + day[period].chatEventCount; }, 0),
        emailsEventCount: data.reduce(function (sum, day) { return sum + day[period].gmailEventCount; }, 0)
    };
}
function calculateTeamTotals(data) {
    if (!data) {
        return {
            meetingsDuration: 0,
            docsDuration: 0,
            chatDuration: 0,
            emailsDuration: 0,
            meetingsEventCount: 0,
            docsEventCount: 0,
            chatEventCount: 0,
            emailsEventCount: 0
        };
    }
    return {
        meetingsDuration: data.reduce(function (sum, day) { return sum + day.team.meetingsDuration; }, 0),
        docsDuration: data.reduce(function (sum, day) { return sum + day.team.docsDuration; }, 0),
        chatDuration: data.reduce(function (sum, day) { return sum + day.team.chatDuration; }, 0),
        emailsDuration: data.reduce(function (sum, day) { return sum + day.team.gmailDuration; }, 0),
        meetingsEventCount: data.reduce(function (sum, day) { return sum + day.team.meetingsEventCount; }, 0),
        docsEventCount: data.reduce(function (sum, day) { return sum + day.team.docsEventCount; }, 0),
        chatEventCount: data.reduce(function (sum, day) { return sum + day.team.chatEventCount; }, 0),
        emailsEventCount: data.reduce(function (sum, day) { return sum + day.team.gmailEventCount; }, 0)
    };
}
var PREVIOUS_PERIOD_STACK_DATA_KEYS = [
    'previousPeriodEmails',
    'previousPeriodChat',
    'previousPeriodMeetings',
    'previousPeriodDocs'
];
var CURRENT_PERIOD_STACK_DATA_KEYS = [
    'currentPeriodEmails',
    'currentPeriodChat',
    'currentPeriodMeetings',
    'currentPeriodDocs'
];
var TEAM_AVERAGE_STACK_DATA_KEYS = [
    'teamAverageEmails',
    'teamAverageChat',
    'teamAverageMeetings',
    'teamAverageDocs'
];
var COMMUNICATION_BY_WEEKDAYS_CHANNEL_KEYS = [
    'emails',
    'chat',
    'meetings',
    'docs'
];
var getWeekdayChannelKeyFromBarDataKey = function (dataKey) {
    if (dataKey.includes('Meetings'))
        return 'meetings';
    if (dataKey.includes('Docs'))
        return 'docs';
    if (dataKey.includes('Chat'))
        return 'chat';
    if (dataKey.includes('Emails'))
        return 'emails';
    return '';
};
var CURRENT_TO_PREVIOUS_WEEKDAY_KEY = {
    currentPeriodEmails: 'previousPeriodEmails',
    currentPeriodChat: 'previousPeriodChat',
    currentPeriodMeetings: 'previousPeriodMeetings',
    currentPeriodDocs: 'previousPeriodDocs'
};
var CURRENT_TO_TEAM_WEEKDAY_KEY = {
    currentPeriodEmails: 'teamAverageEmails',
    currentPeriodChat: 'teamAverageChat',
    currentPeriodMeetings: 'teamAverageMeetings',
    currentPeriodDocs: 'teamAverageDocs'
};
var MEETING_BAR_DATA_KEYS = new Set([
    'previousPeriodMeetings',
    'currentPeriodMeetings',
    'teamAverageMeetings'
]);
export var CommunicationByWeekdays = function (_a) {
    var _b;
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _c = trpc.communicationByWeekdays.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), weekdayData = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    if (isLoading) {
        return _jsx(Loading, {});
    }
    var referenceYear = getTooltipPeriodReferenceYear(dateFrom, dateTo);
    var _d = getPreviousPeriod(dateFrom, dateTo), prevPeriodDateFrom = _d.prevPeriodDateFrom, prevPeriodDateTo = _d.prevPeriodDateTo;
    var currentPeriodComparisonLabel = formatTooltipFilterDateRange(dateFrom, dateTo, referenceYear);
    var previousPeriodComparisonLabel = formatTooltipFilterDateRange(prevPeriodDateFrom, prevPeriodDateTo, referenceYear);
    var onWeekdayBarClick = function (dataKey, stack) {
        var channel = getCommunicationWeekdayChannelFromBarDataKey(dataKey);
        if (!channel) {
            return;
        }
        navigateCommunicationWeekdayBarClick({
            stack: stack,
            channel: channel,
            navigateTo: navigateTo,
            dateFrom: dateFrom,
            dateTo: dateTo,
            prevPeriodDateFrom: prevPeriodDateFrom,
            prevPeriodDateTo: prevPeriodDateTo,
            userId: userId,
            orgUnitId: orgUnitId
        });
    };
    var weekdayBarNavigationProps = function (dataKey, stack) { return ({
        onClick: function () { return onWeekdayBarClick(dataKey, stack); },
        style: { cursor: 'pointer' }
    }); };
    var chartData = (_b = weekdayData === null || weekdayData === void 0 ? void 0 : weekdayData.map(function (day) { return ({
        weekday: day.weekday,
        previousPeriodLabel: previousPeriodComparisonLabel,
        currentPeriodComparisonLabel: currentPeriodComparisonLabel,
        previousPeriodMeetings: day.previousPeriod.meetingsDuration,
        previousPeriodDocs: day.previousPeriod.docsDuration,
        previousPeriodChat: day.previousPeriod.chatDuration,
        previousPeriodEmails: day.previousPeriod.gmailDuration,
        previousPeriodMeetingsEventCount: day.previousPeriod.meetingsEventCount,
        previousPeriodDocsEventCount: day.previousPeriod.docsEventCount,
        previousPeriodChatEventCount: day.previousPeriod.chatEventCount,
        previousPeriodEmailsEventCount: day.previousPeriod.gmailEventCount,
        currentPeriodMeetings: day.currentPeriod.meetingsDuration,
        currentPeriodDocs: day.currentPeriod.docsDuration,
        currentPeriodChat: day.currentPeriod.chatDuration,
        currentPeriodEmails: day.currentPeriod.gmailDuration,
        currentPeriodMeetingsEventCount: day.currentPeriod.meetingsEventCount,
        currentPeriodDocsEventCount: day.currentPeriod.docsEventCount,
        currentPeriodChatEventCount: day.currentPeriod.chatEventCount,
        currentPeriodEmailsEventCount: day.currentPeriod.gmailEventCount,
        teamAverageMeetings: day.team.meetingsDuration,
        teamAverageDocs: day.team.docsDuration,
        teamAverageChat: day.team.chatDuration,
        teamAverageEmails: day.team.gmailDuration,
        teamAverageMeetingsEventCount: day.team.meetingsEventCount,
        teamAverageDocsEventCount: day.team.docsEventCount,
        teamAverageChatEventCount: day.team.chatEventCount,
        teamAverageEmailsEventCount: day.team.gmailEventCount
    }); })) !== null && _b !== void 0 ? _b : [];
    var _e = getPeriodBarChartLayoutProps({
        barGroupCount: chartData.length,
        barsPerGroup: userId ? 3 : 2
    }), barGap = _e.barGap, barSize = _e.barSize, periodXAxis = _e.periodXAxis, periodBarChartMargin = _e.periodBarChartMargin;
    var chartPlotEmpty = isBarChartRowsEmpty(chartData);
    var weekdayMetricLabels = {
        meetings: t('tooltip.metrics.meetings'),
        docs: t('tooltip.metrics.docs'),
        chat: t('tooltip.metrics.chat'),
        emails: t('tooltip.metrics.emails')
    };
    var weekdaySeriesLabelFormatter = createPeriodComparisonSeriesLabelFormatter(weekdayMetricLabels);
    var formatTooltipValue = function (value, dataKey, label, row) {
        var _a;
        var resolved = (_a = row) !== null && _a !== void 0 ? _a : (label ? chartData.find(function (d) { return d.weekday === label; }) : undefined);
        var count = eventCountForDataKey(dataKey, resolved);
        var duration = formatDuration(value, 'seconds');
        var durationLabel = MEETING_BAR_DATA_KEYS.has(dataKey !== null && dataKey !== void 0 ? dataKey : '')
            ? duration
            : "".concat(t('approx'), " ").concat(duration);
        return count !== undefined ? "".concat(count, " (").concat(durationLabel, ")") : durationLabel;
    };
    var currentTotals = calculateTotals(weekdayData, PERIODS.CURRENT);
    var previousTotals = calculateTotals(weekdayData, PERIODS.PREVIOUS);
    var teamTotals = calculateTeamTotals(weekdayData);
    var teamAvgDiffOptions = {
        comparisonType: diffComparisonType.teamAverage,
        comparisonValueFormat: diffComparisonValueFormat.durationSeconds
    };
    var legendItems = [
        {
            type: PERIODS.CURRENT,
            items: [
                {
                    key: 'emails',
                    currentValue: currentTotals.emailsDuration,
                    prevValue: previousTotals.emailsDuration,
                    diffValue: getPercentageDiff(previousTotals.emailsDuration, currentTotals.emailsDuration, { comparisonValueFormat: diffComparisonValueFormat.durationSeconds }),
                    teamAverage: userId
                        ? getPercentageDiff(teamTotals.emailsDuration, currentTotals.emailsDuration, teamAvgDiffOptions)
                        : undefined
                },
                {
                    key: 'chat',
                    currentValue: currentTotals.chatDuration,
                    prevValue: previousTotals.chatDuration,
                    diffValue: getPercentageDiff(previousTotals.chatDuration, currentTotals.chatDuration, { comparisonValueFormat: diffComparisonValueFormat.durationSeconds }),
                    teamAverage: userId
                        ? getPercentageDiff(teamTotals.chatDuration, currentTotals.chatDuration, teamAvgDiffOptions)
                        : undefined
                },
                {
                    key: 'meetings',
                    currentValue: currentTotals.meetingsDuration,
                    prevValue: previousTotals.meetingsDuration,
                    diffValue: getPercentageDiff(previousTotals.meetingsDuration, currentTotals.meetingsDuration, { comparisonValueFormat: diffComparisonValueFormat.durationSeconds }),
                    teamAverage: userId
                        ? getPercentageDiff(teamTotals.meetingsDuration, currentTotals.meetingsDuration, teamAvgDiffOptions)
                        : undefined
                },
                {
                    key: 'docs',
                    currentValue: currentTotals.docsDuration,
                    prevValue: previousTotals.docsDuration,
                    diffValue: getPercentageDiff(previousTotals.docsDuration, currentTotals.docsDuration, { comparisonValueFormat: diffComparisonValueFormat.durationSeconds }),
                    teamAverage: userId
                        ? getPercentageDiff(teamTotals.docsDuration, currentTotals.docsDuration, teamAvgDiffOptions)
                        : undefined
                }
            ]
        }
    ];
    var titleKey = 'app.performanceReview.employeePerformanceReview.communicationSection.communicationDistributionByWeekdays';
    var workDayLabel = t('app.performanceReview.employeePerformanceReview.scheduleAndAttendanceSection.tablesData.workDay');
    var communicationByWeekdaysTooltipStripeSwatchColors = userId
        ? {
            teamAverageChat: COMMUNICATION_BY_WEEKDAYS_CONFIG.chat.teamChartColor,
            teamAverageDocs: COMMUNICATION_BY_WEEKDAYS_CONFIG.docs.teamChartColor,
            teamAverageMeetings: COMMUNICATION_BY_WEEKDAYS_CONFIG.meetings.teamChartColor,
            teamAverageEmails: COMMUNICATION_BY_WEEKDAYS_CONFIG.emails.teamChartColor
        }
        : undefined;
    var getWeekdayPeriodDiff = function (dataKey, row) {
        var _a, _b;
        if (!isCommunicationByWeekdaysBarDataKey(dataKey) || !row) {
            return undefined;
        }
        var previousKey = CURRENT_TO_PREVIOUS_WEEKDAY_KEY[dataKey];
        if (!previousKey) {
            return undefined;
        }
        return getPercentageDiff(Number((_a = row[previousKey]) !== null && _a !== void 0 ? _a : 0), Number((_b = row[dataKey]) !== null && _b !== void 0 ? _b : 0), { comparisonValueFormat: diffComparisonValueFormat.durationSeconds });
    };
    var getWeekdayTeamDiff = function (dataKey, row) {
        var _a, _b;
        if (!userId || !isCommunicationByWeekdaysBarDataKey(dataKey) || !row) {
            return undefined;
        }
        var teamKey = CURRENT_TO_TEAM_WEEKDAY_KEY[dataKey];
        if (!teamKey) {
            return undefined;
        }
        return getPercentageDiff(Number((_a = row[teamKey]) !== null && _a !== void 0 ? _a : 0), Number((_b = row[dataKey]) !== null && _b !== void 0 ? _b : 0), teamAvgDiffOptions);
    };
    var renderWeekdayTooltip = createEdgePositionedBarTooltipContent(_jsx(CustomTooltip, { seriesOrder: __spreadArray([
            'previousPeriodEmails',
            'previousPeriodChat',
            'previousPeriodMeetings',
            'previousPeriodDocs',
            'currentPeriodEmails',
            'currentPeriodChat',
            'currentPeriodMeetings',
            'currentPeriodDocs'
        ], (userId
            ? [
                'teamAverageEmails',
                'teamAverageChat',
                'teamAverageMeetings',
                'teamAverageDocs'
            ]
            : []), true), periodComparisonTooltip: true, seriesLabelFormatter: weekdaySeriesLabelFormatter, formatValue: formatTooltipValue, getPeriodDiff: getWeekdayPeriodDiff, getTeamDiff: userId ? getWeekdayTeamDiff : undefined, periodDiffArrowColor: TablesDiffColorsConfig.GREEN, stripeSwatchColors: communicationByWeekdaysTooltipStripeSwatchColors }), chartData.length);
    return (_jsxs("div", __assign({ className: "w-full" }, { children: [_jsx(WidgetTitle, { title: t(titleKey), description: t('widgetTitleDescriptions.communication.communicationDistributionByWeekdays'), insightType: InsightTypeEnum.communicationDistributionByWeekdays, insightsData: weekdayData || [], refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t(titleKey), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, (weekdayData !== null && weekdayData !== void 0 ? weekdayData : []).map(function (day) {
                                    var _a;
                                    return (_a = {},
                                        _a[workDayLabel] = day.weekday,
                                        _a.CurrentOutgoingEmails = formatDuration(day.currentPeriod.gmailDuration, 'seconds'),
                                        _a.CurrentChat = formatDuration(day.currentPeriod.chatDuration, 'seconds'),
                                        _a.CurrentMeetings = formatDuration(day.currentPeriod.meetingsDuration, 'seconds'),
                                        _a.CurrentDocuments = formatDuration(day.currentPeriod.docsDuration, 'seconds'),
                                        _a.CurrentOutgoingEmailsEventCount = day.currentPeriod.gmailEventCount,
                                        _a.CurrentChatEventCount = day.currentPeriod.chatEventCount,
                                        _a.CurrentMeetingsEventCount = day.currentPeriod.meetingsEventCount,
                                        _a.CurrentDocumentsEventCount = day.currentPeriod.docsEventCount,
                                        _a.PreviousOutgoingEmails = formatDuration(day.previousPeriod.gmailDuration, 'seconds'),
                                        _a.PreviousChat = formatDuration(day.previousPeriod.chatDuration, 'seconds'),
                                        _a.PreviousMeetings = formatDuration(day.previousPeriod.meetingsDuration, 'seconds'),
                                        _a.PreviousDocuments = formatDuration(day.previousPeriod.docsDuration, 'seconds'),
                                        _a.PreviousOutgoingEmailsEventCount = day.previousPeriod.gmailEventCount,
                                        _a.PreviousChatEventCount = day.previousPeriod.chatEventCount,
                                        _a.PreviousMeetingsEventCount = day.previousPeriod.meetingsEventCount,
                                        _a.PreviousDocumentsEventCount = day.previousPeriod.docsEventCount,
                                        _a.TeamOutgoingEmails = formatDuration(day.team.gmailDuration, 'seconds'),
                                        _a.TeamChat = formatDuration(day.team.chatDuration, 'seconds'),
                                        _a.TeamMeetings = formatDuration(day.team.meetingsDuration, 'seconds'),
                                        _a.TeamDocuments = formatDuration(day.team.docsDuration, 'seconds'),
                                        _a.TeamOutgoingEmailsEventCount = day.team.gmailEventCount,
                                        _a.TeamChatEventCount = day.team.chatEventCount,
                                        _a.TeamMeetingsEventCount = day.team.meetingsEventCount,
                                        _a.TeamDocumentsEventCount = day.team.docsEventCount,
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(weekdayData !== null && weekdayData !== void 0 ? weekdayData : []) }) }), _jsx(ChartSeriesVisibility, __assign({ seriesKeys: COMMUNICATION_BY_WEEKDAYS_CHANNEL_KEYS }, { children: function (_a) {
                    var toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible;
                    return (_jsxs(Widget, __assign({ cardClassName: "shadow overflow-x-auto lg:overflow-visible border-b border-gray-200 sm:rounded-lg p-6", className: "lock w-full max-w-full py-2 align-middle sm:px-6 lg:pl-2 lg:pr-2" }, { children: [_jsx("div", __assign({ className: "mb-6 ml-2 flex flex-wrap justify-start gap-8 rounded-lg p-4 lg:gap-8" }, { children: legendItems.flatMap(function (_a) {
                                    var type = _a.type, items = _a.items;
                                    return items.map(function (_a) {
                                        var key = _a.key, currentValue = _a.currentValue, diffValue = _a.diffValue, teamAverage = _a.teamAverage;
                                        var eventCountKey = "".concat(key, "EventCount");
                                        var count = currentTotals[eventCountKey];
                                        var durationLabel = formatDuration(currentValue, 'seconds');
                                        var configKey = key;
                                        return (_jsx(LegendItem, { color: COMMUNICATION_BY_WEEKDAYS_CONFIG[configKey].color, label: weekdayMetricLabels[configKey], currentValueClassName: "inline-flex items-baseline gap-0 text-sm", currentValue: _jsxs(_Fragment, { children: [_jsx("span", __assign({ className: "font-semibold" }, { children: count })), _jsx("span", __assign({ className: "font-normal text-gray-500" }, { children: "\u00A0/\u00A0" })), _jsx("span", __assign({ className: "font-semibold" }, { children: durationLabel }))] }), diffValue: diffValue, teamAverage: teamAverage, arrowColor: TablesDiffColorsConfig.GREEN, stripeChartColor: userId
                                                ? COMMUNICATION_BY_WEEKDAYS_CONFIG[configKey]
                                                    .teamChartColor
                                                : undefined, onClick: function () { return toggleSeries(key); }, isHidden: !isSeriesVisible(key) }, "".concat(type, "-").concat(key)));
                                    });
                                }) })), _jsx(WidgetChartPlotArea, __assign({ isEmpty: chartPlotEmpty }, { children: _jsx(ResponsiveContainer, __assign({ width: "100%", height: 400 }, { children: _jsxs(BarChart, __assign({ data: chartData, barGap: barGap, barSize: barSize, margin: periodBarChartMargin !== null && periodBarChartMargin !== void 0 ? periodBarChartMargin : {
                                            top: 24,
                                            right: 8,
                                            left: 4,
                                            bottom: 4
                                        } }, { children: [userId &&
                                                rechartsDiagonalStripePatternDefs(COMMUNICATION_BY_WEEKDAYS_TEAM_STRIPE_ENTRIES), _jsx(CartesianGrid, { strokeDasharray: "3 3", stroke: "#f3f4f6" }), _jsx(XAxis, __assign({ dataKey: "weekday", axisLine: false, tickLine: false }, periodXAxis)), _jsx(YAxis, { axisLine: false, tickLine: false, tick: { fontSize: 12, fill: '#6b7280' }, tickFormatter: function (v) {
                                                    return formatWeekdayChartAxisSeconds(Number(v));
                                                } }), _jsx(Tooltip, { allowEscapeViewBox: { x: true, y: true }, wrapperStyle: {
                                                    overflow: 'visible',
                                                    zIndex: 50,
                                                    width: 'max-content',
                                                    maxWidth: 'calc(100vw - 2rem)'
                                                }, contentStyle: {
                                                    minWidth: '24rem',
                                                    width: 'max-content',
                                                    maxWidth: 'calc(100vw - 2rem)'
                                                }, content: renderWeekdayTooltip }), _jsx(Bar, __assign({ dataKey: "previousPeriodEmails", fill: COMMUNICATION_BY_WEEKDAYS_CONFIG.emails.prevChartColor, stackId: "prev", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('previousPeriodEmails')) }, weekdayBarNavigationProps('previousPeriodEmails', ComparisonPeriod.Previous), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: PREVIOUS_PERIOD_STACK_DATA_KEYS,
                                                    segmentIndex: 0,
                                                    keyPrefix: 'prev-emails'
                                                }) })), _jsx(Bar, __assign({ dataKey: "previousPeriodChat", fill: COMMUNICATION_BY_WEEKDAYS_CONFIG.chat.prevChartColor, stackId: "prev", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('previousPeriodChat')) }, weekdayBarNavigationProps('previousPeriodChat', ComparisonPeriod.Previous), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: PREVIOUS_PERIOD_STACK_DATA_KEYS,
                                                    segmentIndex: 1,
                                                    keyPrefix: 'prev-chat'
                                                }) })), _jsx(Bar, __assign({ dataKey: "previousPeriodMeetings", fill: COMMUNICATION_BY_WEEKDAYS_CONFIG.meetings.prevChartColor, stackId: "prev", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('previousPeriodMeetings')) }, weekdayBarNavigationProps('previousPeriodMeetings', ComparisonPeriod.Previous), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: PREVIOUS_PERIOD_STACK_DATA_KEYS,
                                                    segmentIndex: 2,
                                                    keyPrefix: 'prev-meetings'
                                                }) })), _jsx(Bar, __assign({ dataKey: "previousPeriodDocs", fill: COMMUNICATION_BY_WEEKDAYS_CONFIG.docs.prevChartColor, stackId: "prev", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('previousPeriodDocs')) }, weekdayBarNavigationProps('previousPeriodDocs', ComparisonPeriod.Previous), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: PREVIOUS_PERIOD_STACK_DATA_KEYS,
                                                    segmentIndex: 3,
                                                    keyPrefix: 'prev-docs'
                                                }) })), _jsx(Bar, __assign({ dataKey: "currentPeriodEmails", fill: COMMUNICATION_BY_WEEKDAYS_CONFIG.emails.chartColor, stackId: "curr", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('currentPeriodEmails')) }, weekdayBarNavigationProps('currentPeriodEmails', ComparisonPeriod.Current), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: CURRENT_PERIOD_STACK_DATA_KEYS,
                                                    segmentIndex: 0,
                                                    keyPrefix: 'curr-emails'
                                                }) })), _jsx(Bar, __assign({ dataKey: "currentPeriodChat", fill: COMMUNICATION_BY_WEEKDAYS_CONFIG.chat.chartColor, stackId: "curr", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('currentPeriodChat')) }, weekdayBarNavigationProps('currentPeriodChat', ComparisonPeriod.Current), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: CURRENT_PERIOD_STACK_DATA_KEYS,
                                                    segmentIndex: 1,
                                                    keyPrefix: 'curr-chat'
                                                }) })), _jsx(Bar, __assign({ dataKey: "currentPeriodMeetings", fill: COMMUNICATION_BY_WEEKDAYS_CONFIG.meetings.chartColor, stackId: "curr", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('currentPeriodMeetings')) }, weekdayBarNavigationProps('currentPeriodMeetings', ComparisonPeriod.Current), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: CURRENT_PERIOD_STACK_DATA_KEYS,
                                                    segmentIndex: 2,
                                                    keyPrefix: 'curr-meetings'
                                                }) })), _jsx(Bar, __assign({ dataKey: "currentPeriodDocs", fill: COMMUNICATION_BY_WEEKDAYS_CONFIG.docs.chartColor, stackId: "curr", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('currentPeriodDocs')) }, weekdayBarNavigationProps('currentPeriodDocs', ComparisonPeriod.Current), { children: renderStackedBarCells({
                                                    chartData: chartData,
                                                    stackDataKeys: CURRENT_PERIOD_STACK_DATA_KEYS,
                                                    segmentIndex: 3,
                                                    keyPrefix: 'curr-docs'
                                                }) })), userId && (_jsxs(_Fragment, { children: [_jsx(Bar, __assign({ dataKey: "teamAverageEmails", fill: rechartsDiagonalStripeFillUrl(communicationByWeekdaysTeamStripePatternId('teamAverageEmails')), stackId: "team", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('teamAverageEmails')) }, { children: renderStackedBarCells({
                                                            chartData: chartData,
                                                            stackDataKeys: TEAM_AVERAGE_STACK_DATA_KEYS,
                                                            segmentIndex: 0,
                                                            keyPrefix: 'team-emails'
                                                        }) })), _jsx(Bar, __assign({ dataKey: "teamAverageChat", fill: rechartsDiagonalStripeFillUrl(communicationByWeekdaysTeamStripePatternId('teamAverageChat')), stackId: "team", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('teamAverageChat')) }, { children: renderStackedBarCells({
                                                            chartData: chartData,
                                                            stackDataKeys: TEAM_AVERAGE_STACK_DATA_KEYS,
                                                            segmentIndex: 1,
                                                            keyPrefix: 'team-chat'
                                                        }) })), _jsx(Bar, __assign({ dataKey: "teamAverageMeetings", fill: rechartsDiagonalStripeFillUrl(communicationByWeekdaysTeamStripePatternId('teamAverageMeetings')), stackId: "team", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('teamAverageMeetings')) }, { children: renderStackedBarCells({
                                                            chartData: chartData,
                                                            stackDataKeys: TEAM_AVERAGE_STACK_DATA_KEYS,
                                                            segmentIndex: 2,
                                                            keyPrefix: 'team-meetings'
                                                        }) })), _jsx(Bar, __assign({ dataKey: "teamAverageDocs", fill: rechartsDiagonalStripeFillUrl(communicationByWeekdaysTeamStripePatternId('teamAverageDocs')), stackId: "team", hide: !isSeriesVisible(getWeekdayChannelKeyFromBarDataKey('teamAverageDocs')) }, { children: renderStackedBarCells({
                                                            chartData: chartData,
                                                            stackDataKeys: TEAM_AVERAGE_STACK_DATA_KEYS,
                                                            segmentIndex: 3,
                                                            keyPrefix: 'team-docs'
                                                        }) }))] }))] })) })) }))] })));
                } }))] })));
};
